import {LocalStorageKeys} from '#/environment/environment';
import {useLocalStorage} from 'react-use';

export const useDismissableInfoTile = (key: string | number): [boolean, () => void] => {
  const [showInfoTile, setShowInfoTile] = useLocalStorage(`${LocalStorageKeys.SHOW_INFO_TILE}-info-tile-${key}`, true);
  const onCloseTile = () => setShowInfoTile(false);
  return [!!showInfoTile, onCloseTile];
};
